import { useEffect, useState } from "react";
import AnnouncementBanner from "@/components/base/AnnouncementBanner";
import { getPublicAnnouncements } from "@/lib/webContentApi";
import { AnnouncementItem } from "@/lib/webContentTypes";

export default function AnnouncementsPage() {
  const [active, setActive] = useState<AnnouncementItem[]>([]);

  useEffect(() => {
    getPublicAnnouncements()
      .then((items) => setActive(items.filter((item) => item.active)))
      .catch(() => setActive([]));
  }, []);

  return (
    <main className="pt-24 pb-20 min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <span className="text-orange-500 text-sm font-semibold uppercase tracking-wider">Informacion oficial</span>
          <h1
            className="text-4xl md:text-5xl font-extrabold text-sky-900 mt-2 mb-4"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Comunicados Importantes
          </h1>
          <p className="text-slate-500 text-lg max-w-xl mx-auto">
            Avisos urgentes, cortes de suministro, mantenciones y cambios en horarios de atencion.
          </p>
        </div>

        {active.length === 0 ? (
          <div className="text-center py-20 text-slate-400">
            <i className="ri-notification-off-line text-5xl mb-4 block"></i>
            <p>No hay comunicados activos en este momento.</p>
          </div>
        ) : (
          <div className="flex flex-col gap-5">
            {active.map((a) => (
              <AnnouncementBanner key={a.id} announcement={a} />
            ))}
          </div>
        )}
      </div>
    </main>
  );
}
